import React from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { Icon, IconType, Theme, Caption, Tooltip } from '@routific/hive';
import { COLUMN_WIDTHS, FamiliarityCol, NumberOfRoutesCol, SpeedCol } from './StyledCols';
import styled from 'styled-components';

export const StyledHeaderRow = styled(Row)`
  width: 100%;
  padding: ${Theme.Spacing.smSpacing} ${Theme.Spacing.mdSpacing};
  border-bottom: 1px solid ${Theme.Colors.gray4};
`;

export const DriverNameHeaderCol = styled(Col)`
  display: inline-flex;
  align-items: center;
  flex: 0 0 ${COLUMN_WIDTHS.name};
`;

const SpeedHeaderCol = styled(SpeedCol)`
  min-width: 0;
  justify-content: flex-start;
`;

const DriverOptionHeader: React.FC = () => {
  const { t } = useTranslation(['components', 'common']);
  return (
    <StyledHeaderRow>
      <DriverNameHeaderCol>
        <Caption type="secondary">
          {t('routesGantt.header.driverNameColumnTitle')}
        </Caption>
      </DriverNameHeaderCol>
      <NumberOfRoutesCol>
        <Caption type="secondary">
          {t('sidebar.routesTitle')}
        </Caption>
      </NumberOfRoutesCol>
      <FamiliarityCol>
        <Caption type="secondary">
          {t('sidebar.familiarityTitle')}
        </Caption>
        <Tooltip title={t('sidebar.familiarityTooltip')}>
          <Icon icon={IconType.Info} type="secondary" size="small" />
        </Tooltip>
      </FamiliarityCol>
      <SpeedHeaderCol>
        <Caption type="secondary">
          {t('driverDetailsPanel.speed.speedLabel')}
        </Caption>
      </SpeedHeaderCol>
    </StyledHeaderRow>
  );
};

export default DriverOptionHeader;
